export const categories = [
  {
    id: 'cat-1',
    name: '基础入门',
    slug: 'basics',
    description: 'Hitozuma 文化的基础概念、定义与入门指南，帮助新手快速建立对 hitozuma 文化的基本认知框架。',
    icon: 'ri-book-open-line',
    articleCount: 8,
  },
  {
    id: 'cat-2',
    name: '作品解析',
    slug: 'works-analysis',
    description: '深度解析经典 hitozuma 作品，从剧情、角色、艺术表现等多维度进行专业评析。',
    icon: 'ri-movie-line',
    articleCount: 12,
  },
  {
    id: 'cat-3',
    name: '文化背景',
    slug: 'cultural-background',
    description: '探讨 hitozuma 文化在日本社会中的历史渊源、社会心理基础与演变脉络。',
    icon: 'ri-landscape-line',
    articleCount: 6,
  },
  {
    id: 'cat-4',
    name: '分类盘点',
    slug: 'category-overview',
    description: '按类型、年代、风格等维度对 hitozuma 内容进行分类梳理与横向对比。',
    icon: 'ri-stack-line',
    articleCount: 9,
  },
  {
    id: 'cat-5',
    name: '资源索引',
    slug: 'resources',
    description: '整理 hitozuma 相关的高质量资源、平台、社区与推荐清单。',
    icon: 'ri-link-m',
    articleCount: 5,
  },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});